import { Linking, ScrollView, StyleSheet, View } from 'react-native';
import { Surface, Text, useTheme } from 'react-native-paper';
import { useTranslation } from 'react-i18next';

// Fixed date of the published policy (ALL-15); never the render date.
const PRIVACY_POLICY_UPDATED_AT = '20/10/2026';
const PRIVACY_POLICY_URL = 'https://alldrivers.pt/politica-de-privacidade/';

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Surface style={styles.container}>
      <ScrollView contentContainerStyle={styles.scrollContainer}>
        <Text style={[styles.title, { color: theme.colors.primary }]}>Política de Privacidade</Text>
        
        <Text style={styles.lastUpdated}>Última atualização: {PRIVACY_POLICY_UPDATED_AT}</Text>

        <Text style={styles.paragraph}>
          A versão completa e em vigor da Política de Privacidade está publicada em{' '}
          <Text
            style={{ color: theme.colors.primary, textDecorationLine: 'underline' }}
            accessibilityRole="link"
            onPress={() => Linking.openURL(PRIVACY_POLICY_URL)}
          >{PRIVACY_POLICY_URL}</Text>.
        </Text>
      </ScrollView>
    </Surface>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollContainer: {
    padding: 20,
    paddingBottom: 40,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
  },
  lastUpdated: {
    fontSize: 14,
    fontStyle: 'italic',
    marginBottom: 20,
    textAlign: 'center',
    opacity: 0.7,
  },
  paragraph: {
    fontSize: 16,
    lineHeight: 24,
    marginBottom: 10,
  },
}); 